import {
    NinchatActionType,
    NinchatCreateAccessAction,
} from '../types/actions'
import ninchatClient, {
    NinchatActionParams,
} from '../NinchatClient'
import {NinchatAccessCreatedEvent} from 'api/types/events'

import {createAsyncThunk} from '@reduxjs/toolkit'

const actionTypePrefix = 'NINCHAT/action'

export const createAccess = createAsyncThunk(
    `${actionTypePrefix}/${NinchatActionType.NinchatCreateAccessAction}`,
    async (arg: NinchatActionParams<NinchatCreateAccessAction>, {rejectWithValue}) => {
        const {...params} = arg

        params.action = NinchatActionType.NinchatCreateAccessAction

        try {
            return await ninchatClient.send(params) as NinchatAccessCreatedEvent
        } catch (err) {
            return rejectWithValue(err)
        }
    },
)
